<template>
  <el-dialog title="海关批量核验" :visible.sync="visible" width="400px" :close-on-click-modal="false">
    <el-form :model="form" label-width="120px">
      <el-form-item label="手动指定核验结果">
        <el-select v-model="form.verifyResult" placeholder="请选择">
          <el-option label="未核验" value="1" />
          <el-option label="已核验有效" value="2" />
          <el-option label="编号无效" value="3" />
          <el-option label="过期" value="4" />
          <el-option label="额度不足" value="5" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <span class="tip-text">待处理选中条数：{{ selectedCount }}</span>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">关闭</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { batchVerify } from '@/api/bondManagement'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'CustomsVerifyModal',
  data() {
    return {
      visible: false,
      selectedData: [],
      form: {
        verifyResult: '2'
      }
    }
  },
  computed: {
    selectedCount() {
      return this.selectedData.length
    }
  },
  methods: {
    show(selectedData) {
      this.selectedData = selectedData
      this.form.verifyResult = '2'
      this.visible = true
    },
    async handleConfirm() {
      if (!this.form.verifyResult) {
        this.$message.warning('请选择核验结果')
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        const uuids = this.selectedData.map(item => item.uuid)
        await batchVerify({ uuids, verifyResult: this.form.verifyResult })
        this.$message.success('核验完毕')
        this.visible = false
        this.$emit('verify-success')
      } finally {
        loading.close()
      }
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-text {
  color: #909399;
  font-size: 14px;
}
</style>
